import React from "react"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"

import { Asset, Decorator } from "components"

const HEADING_OPTIONS = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => children,
  },
  renderMark: {
    [MARKS.BOLD]: text => <span className="text-gold">{text}</span>,
  },
}

function Hero({ heading, description, decorator, image }) {
  return (
    <header className="pb-12 overflow-hidden md:overflow-visible wrapper default-grid gap-y-14 lg:pb-16">
      <div className="pt-8 space-y-6 col-span-full md:col-span-8 md:pt-24">
        <h1 className="h2 text-darkNavy">
          {renderRichText(heading, HEADING_OPTIONS)}
        </h1>
        <p className="lead-copy text-mineralGray" style={{ maxWidth: "33ch" }}>
          {description.description}
        </p>
      </div>
      <div className="hidden col-span-3 col-start-10 pt-24 md:block">
        <div className="sm:-mr-fluidMargin xl:-mr-26">
          <div className="select-none aspect-w-1 aspect-h-1">
            {image && (
              <Asset
                asset={image}
                objectFit="cover"
                objectPosition="center"
                style={{ position: "absolute" }}
              />
            )}
            <div>
              {decorator && (
                <Decorator
                  className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-7 md:-translate-x-1/2 md:left-4"
                  asset={decorator.asset}
                  size="small"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Hero
